import React from "react";

interface FieldDisplayProps {
  label: string;
  value: React.ReactNode;
  valueClassName?: string;
}

/**
 * A component for displaying a label and value in a vertical layout.
 * Used for displaying user information, settings, and other key-value pairs.
 */
export function FieldDisplay({ label, value, valueClassName = "" }: FieldDisplayProps) {
  return (
    <div>
      <label className="text-sm font-semibold text-muted-foreground">{label}</label>
      <p className={`text-base ${valueClassName}`}>{value}</p>
    </div>
  );
}

